import { GitPullRequest } from 'lucide-react'
import { ExternalLink } from '@/components/common/ExternalLink'
import { cn } from '@/lib/utils'

export interface RunPullRequestProps {
  /** Pull request URL */
  prUrl?: string
  /** Pull request ID */
  prId?: number
  /** Branch name */
  branchName?: string
  /** Additional CSS classes */
  className?: string
}

/**
 * PR information section for succeeded runs.
 * 
 * @example
 * ```tsx
 * <RunPullRequest
 *   prUrl="https://dev.azure.com/org/project/_git/repo/pullrequest/1234"
 *   prId={1234}
 *   branchName="agentic/run_20251219_143052_a1b2c3d4"
 * />
 * ```
 */
export function RunPullRequest({
  prUrl,
  prId,
  branchName,
  className,
}: RunPullRequestProps) {
  if (!prUrl) {
    return (
      <div className={cn('text-sm text-muted-foreground', className)}>
        (PR will appear when run succeeds)
      </div>
    )
  }

  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-center gap-2">
        <GitPullRequest className="h-4 w-4 text-muted-foreground" />
        <ExternalLink href={prUrl} className="font-medium">
          PR #{prId || 'N/A'}
        </ExternalLink>
      </div>
      
      {branchName && (
        <div className="text-sm">
          <span className="text-muted-foreground">Branch: </span>
          <code className="text-xs bg-muted px-1 py-0.5 rounded">
            {branchName}
          </code>
        </div>
      )}
      
      <div className="text-sm">
        <span className="text-muted-foreground">Status: </span>
        <span className="text-green-600 font-medium">Open</span>
      </div>
    </div>
  )
}
